import contract from '@mailobj-browser/front/js/contracts/contract.js'
import mains from './mains/mains.js'
import common from './common/common.js'
import deferred from './deferred/deferred.js'

export default contract({
  deferred,
  mains,
  common
})